import { GamepadCircleUpIcon } from './GamepadCircleUpIcon';

/**
 * author: Haley Halcyon
 * id 233618F0-A837-4938-AEF8-93DA6A92A70E
 * name gamepad-circle-up
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gamepad-circle-up.svg
 * tags
 * - Gaming / RPG 
 */
export const ControllerCircleUpIcon = GamepadCircleUpIcon;
export default ControllerCircleUpIcon